import { render, staticRenderFns } from "./NotificationsMain.vue?vue&type=template&id=6cc85cb7&scoped=true"
import script from "./NotificationsMain.vue?vue&type=script&lang=js"
export * from "./NotificationsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc85cb7",
  null
  
)

export default component.exports